import { createAction } from '@reduxjs/toolkit';

import type { IsolatedKey } from 'Addons/fitmentSearch/isolatedKeys';
import type { VehicleActionMeta } from 'Core/actions/response';
import type { ServerModel } from 'Modules/serverApi/types';

export type FitmentSearchResponseMeta = Pick<
  VehicleActionMeta,
  'isAutoVehicleSelectionDisabled' | 'isPartialMode'
> & {
  isolatedKey: IsolatedKey;
};

export const setFitmentSearchResponse = createAction(
  'SET_FITMENT_SEARCH_RESPONSE',
  (
    facets: ServerModel.FacetCategory[],
    isAutoVehicleSelectionDisabled: boolean,
    isPartialMode: boolean,
    isolatedKey: IsolatedKey = null,
  ) => ({
    payload: facets,
    meta: {
      isAutoVehicleSelectionDisabled,
      isPartialMode,
      isolatedKey,
    } satisfies FitmentSearchResponseMeta,
  }),
);

export const setFitmentTableResponse = createAction<ServerModel.FitmentsResponse>(
  'SET_FITMENT_TABLE_RESPONSE',
);
